//import logo from './logo.svg';
import './App.css';
import React  from 'react';
import Header from './view/header/Header';
import Info from './view/info/Info';
import Footer from './view/footer/Footer'
import 'bootstrap/dist/css/bootstrap.min.css'
import Menu from './view/menu/menu';
import Localisation from './view/pages/localisation/Localisation';
import Galerie4 from './view/galerie4/Galerie4.js';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { useState } from "react";
import { useTranslation, I18nextProvider } from 'react-i18next';

function App() {
  const { t, i18n } = useTranslation();

  return (
    
    <div className="App">
      
      
      <I18nextProvider i18n={i18n}>
      <Menu></Menu>
      <br></br>
      <Info></Info>
      <br/><br/>
      <Localisation/>
      
      <br/><br/>
      <Footer></Footer>
      </I18nextProvider>
    </div>
  );
}

export default App;
